import { render, staticRenderFns } from "./HowWorkVideo.vue?vue&type=template&id=44ba8b6e&scoped=true"
import script from "./HowWorkVideo.vue?vue&type=script&lang=js"
export * from "./HowWorkVideo.vue?vue&type=script&lang=js"
import style0 from "./HowWorkVideo.vue?vue&type=style&index=0&id=44ba8b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba8b6e",
  null
  
)

export default component.exports